import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/Accordion';
const FAQS = [{
  q: 'Which dumpster size is right for my project?',
  a: 'Our 10-yard dumpster works well for small cleanouts and light remodeling. Choose 15 yards for medium cleanouts, kitchens, baths, or roofing debris. The 20-yard option is our most popular for large cleanouts and construction projects.'
}, {
  q: 'Can I rent a dumpster for just a few days?',
  a: 'Yes. Every size has a 1–3 day rate as well as a 7-day rate. Choose the rental window that fits your project during booking.'
}, {
  q: 'What materials can I put in the dumpster?',
  a: 'Household junk, furniture, yard waste, renovation debris, and common construction materials are generally accepted. Paint, chemicals, tires, batteries, propane tanks, and hazardous waste are not accepted.'
}, {
  q: 'Do I need to be home for delivery?',
  a: 'No. Provide clear placement notes and make sure there is safe access. We will confirm your delivery window before arrival.'
}, {
  q: 'How do availability and payment holds work?',
  a: 'Choose your delivery date online and we’ll confirm availability for your address. You may pay by card now, or place a card on file as a reservation hold/deposit authorization and pay cash on delivery.'
}];
export function FAQ() {
  return <section id="faq" className="w-full bg-background py-16 md:py-24" data-id="element-169">
      <div className="container max-w-3xl" data-id="element-170">
        <div className="text-center" data-id="element-171">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-172">
            Frequently asked questions
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-173">
            Everything you need to know before you book.
          </p>
        </div>

        <Accordion type="single" defaultValue="item-0" className="mt-10" data-id="element-174">
          {FAQS.map((item, i) => <AccordionItem key={item.q} value={`item-${i}`} data-id="element-175">
              <AccordionTrigger className="text-left text-base" data-id="element-176">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground" data-id="element-177">
                {item.a}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}